/** Convert measured DOM pixels to rem for CSS (never assign raw px to styles). */

export function readRootFontSizePixels() {
  if (typeof document === 'undefined') return 16;
  const parsed = parseFloat(getComputedStyle(document.documentElement).fontSize);
  return Number.isFinite(parsed) && parsed > 0 ? parsed : 16;
}

export function pixelsToRem(pixels) {
  return pixels / readRootFontSizePixels();
}

export function remCSSValue(pixels) {
  return `${pixelsToRem(pixels)}rem`;
}

export function remToPixels(remValue) {
  return remValue * readRootFontSizePixels();
}

/** True when marketing site uses stacked mobile layout (48rem breakpoint). */
export function isMarketingMobileLayout() {
  if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') {
    return false;
  }
  return window.matchMedia('(max-width: 48rem)').matches;
}

export function orbitLayoutForViewport(stackedMobileLayout = isMarketingMobileLayout()) {
  return {
    iconNodeRem: stackedMobileLayout ? 2 : 2.5,
    draftNodeWidthRem: stackedMobileLayout ? 3.75 : 5,
    draftNodeHeightRem: stackedMobileLayout ? 4 : 4.75,
    gapRem: stackedMobileLayout ? 0.55 : 0.875,
    fillRatio: stackedMobileLayout ? 0.82 : 0.9,
    hubCardWidthRem: stackedMobileLayout ? 6 : 7.5,
  };
}

/** IntersectionObserver (incl. Framer Motion viewport) only accepts px or % for rootMargin. */
export function intersectionRootMarginFromRem(top, right, bottom, left) {
  const toMarginPixels = (remValue) => `${remToPixels(remValue)}px`;
  return `${toMarginPixels(top)} ${toMarginPixels(right)} ${toMarginPixels(bottom)} ${toMarginPixels(left)}`;
}
